import { render, staticRenderFns } from "./ProjectManualArticlesPage.vue?vue&type=template&id=45383ed8"
import script from "./ProjectManualArticlesPage.vue?vue&type=script&lang=js"
export * from "./ProjectManualArticlesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports